export function getData(element: HTMLElement, dataAttr: string): string {
  const data = element.dataset[dataAttr];

  if (data == null) {
    throw new TypeError("Requested data attribute " + dataAttr + " from " + element + " but it is missing.");
  }

  return data;
}

export function getNullableData(element: HTMLElement, dataAttr: string): string | undefined {
  return element.dataset[dataAttr];
}

export function findByBindName(bindName: string, root?: HTMLElement): Element {
  return findByBindNameAll(bindName, root)[0];
}

export function findByBindNameAll(bindName: string, root?: HTMLElement): NodeListOf<Element> {
  const element = root == null ? document : root;
  return element.querySelectorAll("[data-js-bind='" + bindName + "']");
}

export function loadJSON(elementId: string): any | undefined {
  const element: Element | null = document.querySelector("script#" + elementId);
  if (element == null) {
    return undefined;
  }
  const contents: string = element!.innerHTML;
  return JSON.parse(contents);
}
